@if (discount.attributes.discount_value_type === 'percentage') {
<span>{{ discount.attributes.value / 100 | percent : '1.0-2' }} Off</span>
} @else if (discount.attributes.discount_value_type === 'fixed_amount') {
<span> {{ discount.attributes.value | currency }} Off </span>
} @else if (discount.attributes.discount_value_type === 'license_extension') {
<span> {{ 'Month' | pluralise : discount.attributes.value }} Free </span>
} @else if (discount.attributes.discount_value_type === 'x_for_y_period') {
<span> {{ 'Year' | pluralise : discount.attributes.value }} Free </span>
} @else if (discount.attributes.discount_value_type === 'x_for_y_seats') {
<span> {{ 'Seat' | pluralise : discount.attributes.value }} Free </span>
}
